// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__3qm3p","Card":"Error_Card__jcaH8","cardWrapper":"Error_cardWrapper___cv-e","imgWrapper":"Error_imgWrapper__1a_-h","btn":"Error_btn__qqMWA"};